import { render } from "./CardExpress.vue?vue&type=template&id=0a3c1fea"
import script from "./CardExpress.vue?vue&type=script&lang=js"
export * from "./CardExpress.vue?vue&type=script&lang=js"

import "./CardExpress.vue?vue&type=style&index=0&id=0a3c1fea&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__